import { MonoTypeOperatorFunction, Observable, OperatorFunction } from 'rxjs';
import { map } from 'rxjs/operators';

export function asType<T>(): OperatorFunction<unknown, T> {
  return map((o) => o as T);
}
